/**
 * Created by Ning Jiang on 2020-03-16.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {TimelineLite} from "gsap";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BonusBunniesGameConfig} from "../../BonusBunniesGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TweenLite, Linear} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";

export class BonusBunniesBaseGameNearWinView extends BaseView {

    private _layer:ScalableLayer;
    private _nearWinTL:TimelineLite;
    private _nearWinFrame:TimelineSprite;

    constructor() {
        super();
        this._layer = StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.REEL_ATTENTION.name);
        this._layer.addChild(this);
    }

    protected initAnimations():void {
        this._nearWinFrame = new TimelineSprite(GameResources.getTextures("BaseAnticipation"));
        this._nearWinFrame.anchor.set(0.5, 0.5);
        this._nearWinFrame.alpha = 0;
        this._nearWinFrame.scale.set(1.09, 1);
        this._nearWinFrame.blendMode = PIXI.BLEND_MODES.SCREEN;
        this.addChild(this._nearWinFrame);
    }

    public playNearWinTL(reel:number):void {
        if(this._nearWinTL && this._nearWinTL.isActive()) {
            this._nearWinTL.pause();
            this._nearWinTL.kill();
        }
        this._nearWinTL = new TimelineLite();
        this._nearWinTL.add(() => this._nearWinFrame.position.x = Helper.getSymbolPositions(reel, 1)[0] - 2);
        this._nearWinTL.add(() => this._nearWinFrame.position.y = Helper.getSymbolPositions(reel, 1)[1] + 55);
        this._nearWinTL.add(() => this._nearWinFrame.playLoop());
        this._nearWinTL.add(new TweenLite(this._nearWinFrame, 0.2, {alpha : 1, ease : Linear.easeNone}));
    }

    public removeNearWinAnimation():void {
        if(this._nearWinTL && this._nearWinTL.isActive()) {
            this._nearWinTL.pause();
            this._nearWinTL.kill();
        }
        this._nearWinFrame.alpha = 0;
        this._nearWinFrame.stopLoop();
    }
}